/**
 * Usage:
 *
 * data-sw-material-family-pricing
 *
 */

var $ = require('js/sw-jquery/sw-jquery');

var PRICING_TABLE_STATE_ID = 'pricingTable';

module.exports = function($fragment) {
  $fragment.swFindWithSelf('[data-sw-material-family-pricing]').each(function() {
    var that = this;

    require([
      'js/lib/models/ModelManager',
      'js/lib/views/ProductPricing'
      ], function(ModelManager, ProductPricing) {
      var $el = $(that);
      var spin = $el.data('swMaterialFamilyPricing');

      new ProductPricing({
        model: ModelManager.getProductEdit(spin),
        stateId: PRICING_TABLE_STATE_ID,
        el: $el
      });
    });
  });
};
